import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d48ba0c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "right-sidebar",
  tabindex: "1",
  style: {"overflow":"auto","z-index":"1!important"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"80px"} }, null, -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "card-body dashboard-card-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12 pl-2 h-100 pr-15" }
const _hoisted_8 = { class: "m-0 p-0 font-size-13 float-right dash-ac-title" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = {
  class: "m-0 p-0 font-size-16 float-right dash-ac-balance",
  style: {}
}
const _hoisted_11 = { id: "paymaster_balance" }
const _hoisted_12 = {
  key: 0,
  class: "col-12 p-0",
  id: "paymaster_chartBody"
}
const _hoisted_13 = {
  id: "chart",
  style: {"height":"80px"}
}
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = { class: "row right-side-total" }
const _hoisted_16 = { class: "col-6 pr-0" }
const _hoisted_17 = {
  class: "font-size-13 font-grey",
  id: "total_balance"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6 p-0 text-right" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-size-13 font-grey" }, "Total Portfolio")
], -1))
const _hoisted_19 = { class: "main-content" }
const _hoisted_20 = { class: "section" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-lg-9 col-md-9 col-sm-9 text-left align-items-center" }
const _hoisted_23 = { class: "d-flex" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "mr-4",
  src: "https://map.admin.caprock.com.au/inlancer-admin/images/dashboard.svg",
  style: {"height":"18px"}
}, null, -1))
const _hoisted_25 = { class: "font-size-16 font-grey" }
const _hoisted_26 = {
  key: 0,
  class: "col-lg-3 col-md-3 col-sm-3 text-right align-items-right"
}
const _hoisted_27 = {
  class: "font-size-14",
  style: {"font-weight":"300","color":"#899aa9 !important","letter-spacing":"1.5px"}
}
const _hoisted_28 = { style: {"border":"1px solid #a5a4a438","padding":"4px 10px"} }
const _hoisted_29 = { class: "tab-content w-100" }
const _hoisted_30 = {
  class: "tab-pane fade show active",
  id: "v-pills-home",
  role: "tabpanel",
  "aria-labelledby": "v-pills-home-tab"
}
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-12" }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-6 mt-4" }
const _hoisted_35 = {
  class: "p-4 bg-white border-radius-10 text-left",
  style: {"min-height":"340px"}
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dash-map-title font-size-14" }, " Basic Information ", -1))
const _hoisted_37 = {
  class: "row",
  style: {"font-size":"14px","color":"#4D5E80","margin-bottom":"20px","padding-bottom":"5px","margin-left":"5px"}
}
const _hoisted_38 = { class: "col-12" }
const _hoisted_39 = { class: "row base_te" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-5",
  style: {"font-size":"14px","color":"#4D5E80"}
}, " Ref Code : ", -1))
const _hoisted_41 = {
  class: "col-7",
  style: {"font-size":"14px","color":"#4D5E80"}
}
const _hoisted_42 = { style: {"font-weight":"bold","color":"#4D5E80","font-size":"14px"} }
const _hoisted_43 = { class: "row base_te" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-5",
  style: {"font-size":"14px","color":"#4D5E80"}
}, " Name : ", -1))
const _hoisted_45 = {
  class: "col-7",
  style: {"font-size":"14px","color":"#4D5E80"}
}
const _hoisted_46 = { style: {"font-weight":"bold","color":"#4D5E80","font-size":"14px"} }
const _hoisted_47 = { class: "row base_te" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, " Type : ", -1))
const _hoisted_49 = { class: "col-7" }
const _hoisted_50 = { style: {"font-weight":"bold","color":"#4D5E80","font-size":"14px"} }
const _hoisted_51 = { class: "row base_te" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-5",
  style: {"font-size":"14px","color":"#4D5E80"}
}, " Location: ", -1))
const _hoisted_53 = {
  class: "col-7",
  style: {"font-size":"14px","color":"#4D5E80"}
}
const _hoisted_54 = { style: {"font-weight":"bold","color":"#4D5E80 !important","font-size":"14px"} }
const _hoisted_55 = { class: "row base_te" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-5",
  style: {"font-size":"14px","color":"#4D5E80"}
}, " Minimum Investment Amount : ", -1))
const _hoisted_57 = {
  class: "col-7",
  style: {"font-size":"14px","color":"#4D5E80"}
}
const _hoisted_58 = { style: {"font-weight":"bold","color":"#4D5E80 !important","font-size":"13px"} }
const _hoisted_59 = { style: {"color":"#4D5E80 !important","font-size":"13px"} }
const _hoisted_60 = { class: "row base_te" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-5",
  style: {"font-size":"14px","color":"#4D5E80"}
}, " Interest Rate : ", -1))
const _hoisted_62 = {
  class: "col-7",
  style: {"font-size":"14px","color":"#4D5E80"}
}
const _hoisted_63 = {
  key: 0,
  style: {"font-weight":"bold","color":"#4D5E80 !important","font-size":"13px"}
}
const _hoisted_64 = { class: "row base_te" }
const _hoisted_65 = {
  key: 0,
  class: "col-5",
  style: {"font-size":"14px","color":"#4D5E80"}
}
const _hoisted_66 = {
  key: 1,
  class: "col-7",
  style: {"font-size":"14px","color":"#4D5E80"}
}
const _hoisted_67 = { style: {"font-weight":"bold","color":"#4D5E80 !important","font-size":"13px"} }
const _hoisted_68 = { class: "row base_te" }
const _hoisted_69 = {
  key: 0,
  class: "col-5",
  style: {"font-size":"14px","color":"#4D5E80"}
}
const _hoisted_70 = {
  key: 1,
  class: "col-7",
  style: {"font-size":"14px","color":"#4D5E80"}
}
const _hoisted_71 = { style: {"font-weight":"bold","color":"#4D5E80 !important","font-size":"13px"} }
const _hoisted_72 = { class: "row base_te" }
const _hoisted_73 = {
  key: 0,
  class: "col-5",
  style: {"font-size":"14px","color":"#4D5E80"}
}
const _hoisted_74 = {
  key: 1,
  class: "col-7",
  style: {"font-size":"14px","color":"#4D5E80"}
}
const _hoisted_75 = { style: {"font-weight":"bold","color":"#4D5E80 !important","font-size":"13px"} }
const _hoisted_76 = { class: "row base_te" }
const _hoisted_77 = {
  key: 0,
  class: "col-5",
  style: {"font-size":"14px","color":"#4D5E80"}
}
const _hoisted_78 = {
  key: 1,
  class: "col-7",
  style: {"font-size":"14px","color":"#4D5E80"}
}
const _hoisted_79 = { style: {"font-weight":"bold","color":"#4D5E80 !important","font-size":"13px"} }
const _hoisted_80 = { class: "row base_te" }
const _hoisted_81 = {
  key: 0,
  class: "col-5",
  style: {"font-size":"14px","color":"#4D5E80"}
}
const _hoisted_82 = {
  key: 1,
  class: "col-7",
  style: {"font-size":"14px","color":"#4D5E80"}
}
const _hoisted_83 = { style: {"font-weight":"bold","color":"#4D5E80 !important","font-size":"13px"} }
const _hoisted_84 = { class: "row base_te" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-5",
  style: {"font-size":"14px","color":"#4D5E80"}
}, " Asset Type : ", -1))
const _hoisted_86 = {
  class: "col-7",
  style: {"font-size":"14px","color":"#4D5E80"}
}
const _hoisted_87 = { style: {"font-weight":"bold","color":"#4D5E80 !important","font-size":"13px"} }
const _hoisted_88 = { class: "row base_te" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-5",
  style: {"font-size":"14px","color":"#4D5E80"}
}, " Asset Sector ", -1))
const _hoisted_90 = {
  class: "col-7",
  style: {"font-size":"14px","color":"#4D5E80"}
}
const _hoisted_91 = { style: {"font-weight":"bold","color":"#4D5E80 !important","font-size":"13px"} }
const _hoisted_92 = { class: "col-6 mt-4" }
const _hoisted_93 = {
  class: "p-4 bg-white border-radius-10 text-left",
  style: {"min-height":"340px"}
}
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-size-14 dash-map-title" }, " Documents ")
], -1))
const _hoisted_95 = { class: "font-size-14 font-grey" }
const _hoisted_96 = ["href"]
const _hoisted_97 = ["title"]
const _hoisted_98 = {
  style: {"height":"25px","width":"25px"},
  width: "752pt",
  height: "752pt",
  "inkscape:version": "0.92.3 (2405546, 2018-03-11)",
  "sodipodi:docname": "d-icon.svg",
  version: "1.1",
  viewBox: "0 0 752 752",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
  "xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
}
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "grey",
  d: "m552.19 261.61c-13.464-77.229-80.529-135.11-160.89-135.11-64.695 0-122.75 38.124-148.96 96.303-1.6582-0.0793-3.3005-0.11901-4.935-0.11901-54.395 0-101.6 34.545-118.49 85.298-66.71 21.905-112.37 84.171-112.37 155.18 0 90.171 73.357 163.52 163.52 163.52h394.38c100.78 0 182.76-81.981 182.76-182.76 0-104.84-88.648-189.85-195.01-182.32zm-160.89 297.74-125.04-134.66h76.952v-86.568h96.191v86.568h76.952z",
  "stroke-width": "2.0311",
  "inkscape:connector-curvature": "0"
}, null, -1))
const _hoisted_100 = {
  key: 0,
  style: {"margin-left":"10px","padding-bottom":"4px"}
}
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-size-14 font-grey" }, " No Document Found ", -1))
const _hoisted_102 = [
  _hoisted_101
]
const _hoisted_103 = { class: "col-12 mt-4" }
const _hoisted_104 = {
  class: "bg-white border-radius-10 text-left mb-4",
  style: {"padding":"20px"}
}
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "dash-map-title font-size-14 mb-0" }, " Terms & Conditions / Descriptions ", -1))
const _hoisted_106 = {
  style: {"color":"#908a8a","margin-left":"10px"},
  class: "pre-formatted"
}
const _hoisted_107 = { class: "col-12 mt-4" }
const _hoisted_108 = {
  class: "bg-white border-radius-10 text-left mb-4",
  style: {"padding":"10px"}
}
const _hoisted_109 = {
  class: "login-card bg-white p-4",
  style: {"border-radius":"6px"}
}
const _hoisted_110 = { class: "login-body" }
const _hoisted_111 = { class: "form-group mt-1 mb-0" }
const _hoisted_112 = { class: "dash-map-title font-size-16 mb-0" }
const _hoisted_113 = { class: "label float-right" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_115 = { class: "row" }
const _hoisted_116 = { class: "form-group col-md-6" }
const _hoisted_117 = { class: "form-group col-md-6" }
const _hoisted_118 = { class: "form-group col-md-6" }
const _hoisted_119 = { class: "form-group col-md-6" }
const _hoisted_120 = { class: "form-group col-md-6" }
const _hoisted_121 = { class: "form-group mt-1 mb-0" }
const _hoisted_122 = {
  style: {"height":"15px","width":"15px","margin":"5px"},
  width: "100mm",
  height: "100mm",
  version: "1.1",
  viewBox: "0 0 100 100"
}
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "m139.21 139.21h473.58v473.58h-473.58z",
      "inkscape:connector-curvature": "0"
    })
  ])
], -1))
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", {
  transform: "translate(0,-197)",
  "inkscape:groupmode": "layer",
  "inkscape:label": "Layer 1"
}, [
  /*#__PURE__*/_createElementVNode("g", { transform: "matrix(1.6371 0 0 1.6371 16.358 -155.86)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "m-8.417 217.52h57.655v57.655h-57.655z",
      fill: "none",
      stroke: "#000",
      "stroke-miterlimit": "10",
      "stroke-width": "1.6707",
      "inkscape:connector-curvature": "0"
    }),
    /*#__PURE__*/_createElementVNode("g", {
      transform: "matrix(.35278 0 0 .35278 -152.74 113.7)",
      "clip-path": "url(#a)"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        transform: "matrix(4.7358,0,0,4.7358,139.21,139.21)",
        d: "m64.04 52.74 6.31 6.9806 13.98-20.311",
        fill: "none",
        stroke: "#000",
        "stroke-linecap": "square",
        "stroke-miterlimit": "10",
        "stroke-width": "5",
        "inkscape:connector-curvature": "0"
      })
    ])
  ])
], -1))
const _hoisted_125 = {
  style: {"height":"15px","width":"15px","margin":"5px"},
  width: "100mm",
  height: "100mm",
  viewBox: "0 0 100 100"
}
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "m139.21 139.21h473.58v473.58h-473.58z",
      "inkscape:connector-curvature": "0"
    })
  ])
], -1))
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", {
  transform: "translate(0,-197)",
  "inkscape:groupmode": "layer",
  "inkscape:label": "Layer 1"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "m2.5789 200.25h94.389v94.389h-94.389z",
    fill: "none",
    stroke: "#000",
    "stroke-miterlimit": "10",
    "stroke-width": "2.7351",
    "inkscape:connector-curvature": "0"
  })
], -1))
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "I confirm I have read the Information Memorandum and agree to the Terms & Conditions", -1))
const _hoisted_129 = { class: "errorMsg danger ml-2" }
const _hoisted_130 = { class: "row justify-content-center mx-md-0 mx-1 mb-1 mt-0" }
const _hoisted_131 = { class: "col-md-12 col-12 px-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic = _resolveComponent("basic")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_sodipodi58namedview = _resolveComponent("sodipodi:namedview")!
  const _component_CurrencyInput = _resolveComponent("CurrencyInput")!
  const _component_toast = _resolveComponent("toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_basic),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("aside", null, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customer_accounts, (ac) => {
              return (_openBlock(), _createElementBlock("div", {
                style: {"pointer-events":"none"},
                class: "dashboard-card bg-light mb-0",
                key: ac.userac_id
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("p", _hoisted_8, _toDisplayString(ac.ac_name), 1),
                      _hoisted_9,
                      _createElementVNode("p", _hoisted_10, [
                        _createElementVNode("b", _hoisted_11, "$" + _toDisplayString(ac.default_currency_balance.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1)
                      ])
                    ]),
                    (ac.default_currency_balance>0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_apexchart, {
                              type: "area",
                              height: "100",
                              options: ac.chartOptions,
                              series: ac.series
                            }, null, 8, ["options", "series"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, "$" + _toDisplayString(_ctx.total_ac_balance), 1)
              ]),
              _hoisted_18
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("section", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("span", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("h5", _hoisted_25, [
                _createElementVNode("b", null, _toDisplayString(_ctx.inv_menu['inv_name']) + " " + _toDisplayString(typeof _ctx.inv_menu['inv_investment_type'] !='undefined' ? ' - '+_ctx.inv_menu['inv_investment_type'] :''), 1)
              ])
            ])
          ]),
          (_ctx.is_invested!=0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("h5", _hoisted_27, [
                  _createElementVNode("b", _hoisted_28, "Invested " + _toDisplayString(_ctx.is_invested) + " time", 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("p", null, [
                        _hoisted_36,
                        _createElementVNode("span", {
                          class: _normalizeClass(_ctx.inv_menu['inv_status']=='Active'?'active_s':'pending_s'),
                          style: {"font-size":"13px","float":"right"}
                        }, _toDisplayString(_ctx.inv_menu['inv_status']), 3)
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            _hoisted_40,
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.inv_menu['inv_ref_code']), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_43, [
                            _hoisted_44,
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.inv_menu['inv_name']), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_47, [
                            _hoisted_48,
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.inv_menu['inv_type']), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_51, [
                            _hoisted_52,
                            _createElementVNode("div", _hoisted_53, [
                              _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.inv_menu['location']), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_55, [
                            _hoisted_56,
                            _createElementVNode("div", _hoisted_57, [
                              _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.inv_menu['inv_amount']), 1),
                              _createElementVNode("span", _hoisted_59, " (Currency - " + _toDisplayString(_ctx.inv_menu['currency']) + ") ", 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_60, [
                            _hoisted_61,
                            _createElementVNode("div", _hoisted_62, [
                              (_ctx.inv_menu['inv_interest_rate'])
                                ? (_openBlock(), _createElementBlock("span", _hoisted_63, _toDisplayString(_ctx.inv_menu['inv_interest_rate']) + " % ", 1))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_64, [
                            (_ctx.inv_menu['inv_coupon']!=null )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_65, " Coupon : "))
                              : _createCommentVNode("", true),
                            (_ctx.inv_menu['inv_coupon']!=null )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                  _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.inv_menu['inv_coupon']), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_68, [
                            (_ctx.inv_menu['inv_term_type']!=null && _ctx.inv_menu['inv_term']!=null )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_69, " Term : "))
                              : _createCommentVNode("", true),
                            (_ctx.inv_menu['inv_term_type']!=null & _ctx.inv_menu['inv_term']!=null )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                  _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.inv_menu['inv_term']) + " " + _toDisplayString(_ctx.inv_menu['inv_term_type']), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_72, [
                            (_ctx.inv_menu['inv_subscription']!=null )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_73, " Subscription : "))
                              : _createCommentVNode("", true),
                            (_ctx.inv_menu['inv_subscription']!=null )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                  _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.inv_menu['inv_subscription']) + " " + _toDisplayString(_ctx.inv_menu['inv_subscription_other']?'- '+_ctx.inv_menu['inv_subscription_other']:''), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_76, [
                            (_ctx.inv_menu['inv_issue_price']!=null )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_77, " Issue Price : "))
                              : _createCommentVNode("", true),
                            (_ctx.inv_menu['inv_issue_price']!=null )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                                  _createElementVNode("span", _hoisted_79, _toDisplayString(_ctx.inv_menu['inv_issue_price']), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_80, [
                            (_ctx.inv_menu['inv_rank']!=null )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_81, " Rank : "))
                              : _createCommentVNode("", true),
                            (_ctx.inv_menu['inv_rank']!=null )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                  _createElementVNode("span", _hoisted_83, _toDisplayString(_ctx.inv_menu['inv_rank']), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_84, [
                            _hoisted_85,
                            _createElementVNode("div", _hoisted_86, [
                              _createElementVNode("span", _hoisted_87, _toDisplayString(_ctx.inv_menu['inv_asset_type']), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_88, [
                            _hoisted_89,
                            _createElementVNode("div", _hoisted_90, [
                              _createElementVNode("span", _hoisted_91, _toDisplayString(_ctx.inv_menu['inv_asset_sector']), 1)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_92, [
                    _createElementVNode("div", _hoisted_93, [
                      _hoisted_94,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.docs, (doc) => {
                        return (_openBlock(), _createElementBlock("p", {
                          style: {"margin-left":"10px","padding-bottom":"4px"},
                          key: doc.doc_id
                        }, [
                          _createElementVNode("span", _hoisted_95, _toDisplayString(doc.doc_name), 1),
                          _createElementVNode("a", {
                            href: doc.doc_url,
                            target: "_blank"
                          }, [
                            _createElementVNode("span", {
                              title: 'Download ' +doc.doc_name,
                              class: "p-cursor font-size-14 font-grey float-right"
                            }, [
                              (_openBlock(), _createElementBlock("svg", _hoisted_98, [
                                _createVNode(_component_sodipodi58namedview, {
                                  bordercolor: "#666666",
                                  borderopacity: "1",
                                  gridtolerance: "10",
                                  guidetolerance: "10",
                                  "inkscape:current-layer": "svg4",
                                  "inkscape:cx": "90.436979",
                                  "inkscape:cy": "458.00126",
                                  "inkscape:pageopacity": "0",
                                  "inkscape:pageshadow": "2",
                                  "inkscape:window-height": "667",
                                  "inkscape:window-maximized": "1",
                                  "inkscape:window-width": "1366",
                                  "inkscape:window-x": "0",
                                  "inkscape:window-y": "27",
                                  "inkscape:zoom": "0.23537234",
                                  objecttolerance: "10",
                                  pagecolor: "#ffffff",
                                  showgrid: "false"
                                }),
                                _hoisted_99
                              ]))
                            ], 8, _hoisted_97)
                          ], 8, _hoisted_96)
                        ]))
                      }), 128)),
                      (_ctx.docs.length==0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_100, _hoisted_102))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_103, [
                    _createElementVNode("div", _hoisted_104, [
                      _hoisted_105,
                      _createElementVNode("p", _hoisted_106, _toDisplayString(_ctx.inv_menu['inv_terms']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_107, [
                    _createElementVNode("div", _hoisted_108, [
                      _createElementVNode("div", _hoisted_109, [
                        _createElementVNode("div", _hoisted_110, [
                          _createElementVNode("div", _hoisted_111, [
                            _createElementVNode("h5", _hoisted_112, [
                              _createTextVNode("Investment Application"),
                              _createElementVNode("label", _hoisted_113, "Date : " + _toDisplayString(_ctx.current_date), 1)
                            ]),
                            _hoisted_114
                          ]),
                          _createElementVNode("div", _hoisted_115, [
                            _createElementVNode("div", _hoisted_116, [
                              _createVNode(_component_CurrencyInput, {
                                onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removeTagErr($event))),
                                placeholder: "Amount you would like to invest",
                                modelValue: _ctx.form.amount,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.amount) = $event)),
                                "data-curency": (typeof _ctx.inv_menu['currency']!='undefined' && _ctx.inv_menu['currency']!=null) ? _ctx.inv_menu['currency']:'USD',
                                name: "amount",
                                id: "amount",
                                class: "input-border form-control selected-field",
                                options: _ctx.amount_options
                              }, null, 8, ["modelValue", "data-curency", "options"])
                            ]),
                            _createElementVNode("div", _hoisted_117, [
                              _withDirectives(_createElementVNode("input", {
                                onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.removeTagErr($event))),
                                onfocus: "this.setAttribute('autocomplete','disable-autocomplete');",
                                autocomplete: "off",
                                type: "text",
                                placeholder: "Your Name",
                                class: "input-border form-control selected-field",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.e_name) = $event)),
                                name: "e_name",
                                id: "e_name",
                                required: ""
                              }, null, 544), [
                                [_vModelText, _ctx.form.e_name]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_118, [
                              _withDirectives(_createElementVNode("input", {
                                onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.removeTagErr($event))),
                                onfocus: "this.setAttribute('autocomplete','disable-autocomplete');",
                                autocomplete: "off",
                                type: "text",
                                placeholder: "Your Email Address",
                                class: "input-border form-control selected-field",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.e_email) = $event)),
                                name: "e_email",
                                id: "e_email",
                                required: ""
                              }, null, 544), [
                                [_vModelText, _ctx.form.e_email]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_119, [
                              _withDirectives(_createElementVNode("input", {
                                onInput: _cache[6] || (_cache[6] = ($event: any) => {_ctx.checkPhone($event);}),
                                onfocus: "this.setAttribute('autocomplete','disable-autocomplete');",
                                autocomplete: "off",
                                type: "text",
                                placeholder: "Your Phone Number",
                                class: "input-border form-control selected-field",
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.e_phone_no) = $event)),
                                name: "e_phone_no",
                                id: "e_phone_no",
                                required: ""
                              }, null, 544), [
                                [_vModelText, _ctx.form.e_phone_no]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_120, [
                              _withDirectives(_createElementVNode("input", {
                                onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.removeTagErr($event))),
                                onfocus: "this.setAttribute('autocomplete','disable-autocomplete');",
                                autocomplete: "off",
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.e_dob) = $event)),
                                type: "date",
                                placeholder: "Your Email Address",
                                class: "input-border form-control selected-field",
                                name: "e_dob",
                                id: "e_dob",
                                required: ""
                              }, null, 544), [
                                [_vModelText, _ctx.form.e_dob]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_121, [
                            (this.confirm==1)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: "p-cursor",
                                  onClick: _cache[10] || (_cache[10] = ($event: any) => {_ctx.confirm=0;_ctx.confirm_error=''})
                                }, [
                                  (_openBlock(), _createElementBlock("svg", _hoisted_122, [
                                    _hoisted_123,
                                    _createVNode(_component_sodipodi58namedview, {
                                      id: "base",
                                      bordercolor: "#666666",
                                      borderopacity: "1.0",
                                      "inkscape:current-layer": "layer1",
                                      "inkscape:cx": "164.85456",
                                      "inkscape:cy": "262.3356",
                                      "inkscape:document-units": "mm",
                                      "inkscape:pageopacity": "0.0",
                                      "inkscape:pageshadow": "2",
                                      "inkscape:window-height": "667",
                                      "inkscape:window-maximized": "1",
                                      "inkscape:window-width": "1366",
                                      "inkscape:window-x": "0",
                                      "inkscape:window-y": "27",
                                      "inkscape:zoom": "0.35",
                                      pagecolor: "#ffffff",
                                      showgrid: "false"
                                    }),
                                    _hoisted_124
                                  ]))
                                ]))
                              : _createCommentVNode("", true),
                            (this.confirm==0)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 1,
                                  class: "p-cursor",
                                  onClick: _cache[11] || (_cache[11] = ($event: any) => {_ctx.confirm=1;_ctx.confirm_error=''})
                                }, [
                                  (_openBlock(), _createElementBlock("svg", _hoisted_125, [
                                    _hoisted_126,
                                    _createVNode(_component_sodipodi58namedview, {
                                      id: "base",
                                      bordercolor: "#666666",
                                      borderopacity: "1.0",
                                      "inkscape:current-layer": "layer1",
                                      "inkscape:cx": "164.85456",
                                      "inkscape:cy": "262.3356",
                                      "inkscape:document-units": "mm",
                                      "inkscape:pageopacity": "0.0",
                                      "inkscape:pageshadow": "2",
                                      "inkscape:window-height": "667",
                                      "inkscape:window-maximized": "1",
                                      "inkscape:window-width": "1366",
                                      "inkscape:window-x": "0",
                                      "inkscape:window-y": "27",
                                      "inkscape:zoom": "0.35",
                                      pagecolor: "#ffffff",
                                      showgrid: "false"
                                    }),
                                    _hoisted_127
                                  ]))
                                ]))
                              : _createCommentVNode("", true),
                            _hoisted_128,
                            _createElementVNode("small", _hoisted_129, _toDisplayString(_ctx.confirm_error), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_130, [
                          _createElementVNode("div", _hoisted_131, [
                            _createElementVNode("button", {
                              id: "subBtn",
                              type: "button",
                              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args))),
                              class: "btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                            }, " Invest Now ")
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_toast, { ref: "toast" }, null, 512)
  ], 64))
}